import { render, staticRenderFns } from "./PlatformServiceView.vue?vue&type=template&id=203bbc59&scoped=true"
import script from "./PlatformServiceView.vue?vue&type=script&lang=js"
export * from "./PlatformServiceView.vue?vue&type=script&lang=js"
import style0 from "./PlatformServiceView.vue?vue&type=style&index=0&id=203bbc59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203bbc59",
  null
  
)

export default component.exports